import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
var InquiryComponent = function InquiryComponent(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-5 left-1/2 -translate-x-1/2 flex w-[calc(100%-24px)] items-center justify-between rounded-lg border border-[#D6DFE9] bg-white p-3 shadow-[0px_2px_9px_0px_rgba(0,0,0,0.10)] z-[100] md:[position:unset] md:w-full md:translate-x-0 md:border-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-bold leading-4 text-start text-[#0d0db5]"
  }, t("questions", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: "cursor-pointer max-w-[97px] min-h-[40px] p-3 rounded text-sm font-bold leading-4 outline-none border-0 shrink-0 bg-[#0d0db5] text-white"
  }, t("contact", {
    ns: "web_tracking"
  })))));
};
export default InquiryComponent;